import { render, staticRenderFns } from "./TableProfitPlayer.vue?vue&type=template&id=3f478d55"
import script from "./TableProfitPlayer.js?vue&type=script&lang=js&external"
export * from "./TableProfitPlayer.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports